const latinize = require('latinize');

function getJobUri(requisitionId, jobTitle) {
    if (typeof requisitionId === 'undefined') {
        throw new Error('requisitionId is required');
    }
    if (typeof jobTitle === 'undefined') {
        throw new Error('jobTitle is required');
    }
    // Replace accented characters with their non-accented counter parts
    let latinized = latinize(jobTitle);
    // Replace all non-regular URL, hyphens and space characters with a empty
    let jobUrl = latinized.replace(/[^a-zA-Z0-9-\s]/g, '');
    // Replace consequtive spaces or hyphens with a single hyphen
    jobUrl = jobUrl.replace(/[-\s]+/g, '-');
    // Lower case everything
    jobUrl = jobUrl.toLowerCase();
    let reqId = requisitionId.toLowerCase();

    return `${reqId}-${jobUrl}`;
}

module.exports = getJobUri;
